import { Lang, MultiLangHelper } from "../../shared/multi.lang";

export interface ILangSupport {
    lang: Lang;

    title: string;
}

class TurkishSupport implements ILangSupport {
    lang = Lang.TR;

    title = 'Şirketler'
}
const turkishSupport = new TurkishSupport();

class EnglishSupport implements ILangSupport {
    lang = Lang.EN;

    title = 'Companies';
}
const englishSupport = new EnglishSupport();

const langHelper = new MultiLangHelper<ILangSupport>(turkishSupport, englishSupport);
export { langHelper }
